export const isValidEmbedLink = (url: string): boolean => {
    const pattern = /^https?:\/\/(www\.)?google\.com\/maps\/embed\?pb=/;
    return pattern.test(url);
  };
  
  export const extractSrcFromIframe = (input: string): string => {
    if (input.includes("<iframe")) {
      const match = input.match(/src="([^"]+)"/);
      return match?.[1] ?? input;
    }
    return input;
  };
  
  /**
   * Processes a Google Maps input, validates it and returns result.
   */
  export const handleMapInput = (rawValue: string) => {
    const cleaned = extractSrcFromIframe(rawValue);
    const valid = isValidEmbedLink(cleaned);
    return { cleaned, valid };
  };